/*
  Уход со страницы «Новый лицевой счёт», пока первый шаг набран и не отправлен.

  Аудит 28.10.2026, раздел 5.3: «К реестру» и «Загрузить файл вместо ручного ввода» уводили
  со страницы без вопроса, и набранные номер и адрес пропадали. Здесь сначала вопрос.

  Граница: ссылки меню и кнопка «Назад» браузера идут мимо этих двух ссылок. Закрытие
  вкладки и перезагрузку страницы ловит `beforeunload`; а внутренние переходы мимо ссылок
  страницы закрыл бы только маршрутизатор с блокировщиком (`useBlocker`), для него
  приложению нужен маршрутизатор данных. Строка в реестре компромиссов.
*/

import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Confirm } from '../Common.jsx'

export default function NewAccountLeave({ dirty, links }) {
  const navigate = useNavigate()
  const [target, setTarget] = useState(null)

  useEffect(() => {
    if (!dirty) return undefined
    const warn = (event) => event.preventDefault()
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [dirty])

  const ask = (to) => (event) => {
    if (!dirty) return
    event.preventDefault()
    setTarget(to)
  }

  return (
    <>
      {links.map((link) => (
        <Link key={link.to} className="button button--quiet" to={link.to} onClick={ask(link.to)}>
          {link.title}
        </Link>
      ))}
      {target ? (
        <Confirm
          title="Уйти без сохранения?"
          action="Уйти без сохранения"
          onConfirm={() => navigate(target)}
          onCancel={() => setTarget(null)}
        >
          Номер и адрес на первом шаге набраны, но счёт ещё не заведён. Если уйти сейчас, набранное
          пропадёт. Чтобы сохранить, нажмите «Отмена» и заведите счёт.
        </Confirm>
      ) : null}
    </>
  )
}
